const ISSERVER = typeof window === "undefined";


export const getsessionhouse = () => {
    if (!ISSERVER) {
        const houseobject = sessionStorage?.getItem("house");
        if (houseobject) return JSON.parse(houseobject);
        else return null;
    }
}

export const setsessionhouse = (house) => {
    sessionStorage?.setItem("house", JSON.stringify(house));
}


export const removehousesession = () => {
    sessionStorage?.removeItem("house");
}

//cart
export const setsessioncart = (cart) => {
    localStorage?.setItem("cart", JSON.stringify(cart));
}
export const getsessioncart = () => {
    if (!ISSERVER) {
        const houseobject = localStorage?.getItem("cart");
        if (houseobject) return JSON.parse(houseobject);
        else return null;
    }
}

//user operations
export const getsessionuser = () => {
    if (!ISSERVER) {
        const userobject = localStorage?.getItem("user");
        if (userobject) return JSON.parse(userobject);
        else return null;
    }
}
export const setsessionuser = (user) => {
    localStorage?.setItem("user", JSON.stringify(user));
}
export const setlocaluser = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
}

//search requests
export const settrackingnumbers = (trackingnumbers) => {
    sessionStorage?.setItem("trackingnumbers", JSON.stringify(trackingnumbers));
}
export const gettrackingnumbers = () => {
    if (!ISSERVER) {
        const trackingnumbers = localStorage?.getItem("trackingnumbers");
        if (trackingnumbers) return JSON.parse(trackingnumbers);
        else return null;
    }
}



export const logoutuser = () => {
    localStorage?.removeItem("user");
    localStorage?.removeItem("cart")
    sessionStorage?.removeItem("user")
    sessionStorage?.removeItem("cart")
    sessionStorage?.removeItem("house")
}










